import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  MenuBannerTranslationInput
} from "../../types/globalTypes";
import TranslationsMenuBannerPage, {
  fieldNames
} from "../components/TranslationsMenuBannerPage";
import { TypedUpdateMenuBannerTranslations } from "../mutations";
import { TypedMenuBannerTranslationDetails } from "../queries";
import { UpdateMenuBannerTranslations } from "../types/UpdateMenuBannerTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsMenuBannerQueryParams {
  activeField: string;
}
export interface TranslationsMenuBannerProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsMenuBannerQueryParams;
}

const TranslationsMenuBanner: React.FC<TranslationsMenuBannerProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateMenuBannerTranslations) => {
    if (data.menuBannerTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedMenuBannerTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {pageHeaderTranslations => (
        <TypedUpdateMenuBannerTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: MenuBannerTranslationInput = {};
              if (field === fieldNames.title) {
                input.title = data;
              } else if (field === fieldNames.url) {
                input.url = data;
              } else if (field === fieldNames.subtitle) {
                input.subtitle = data;
              } else if (field === fieldNames.h5ImageUrl) {
                input.h5ImageUrl = data;
              } else if (field === fieldNames.pcImageUrl) {
                input.pcImageUrl = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsMenuBannerPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.menuBanner, id)
                  )
                }
                onSubmit={handleSubmit}
                menuBanner={maybe(() => pageHeaderTranslations.data.menuBanner)}
              />
            );
          }}
        </TypedUpdateMenuBannerTranslations>
      )}
    </TypedMenuBannerTranslationDetails>
  );
};
TranslationsMenuBanner.displayName = "TranslationsMenuBanner";
export default TranslationsMenuBanner;
